import React from "react";
import { createRoot } from 'react-dom/client';
import VertexSearchPageApp from "./components/vertex-search-page-app";

const entryDiv = document.getElementById('vertex-search-page-app');

if (entryDiv) {
    const root = createRoot(entryDiv);
    const { epiProps, showHealthyChildrenBranding, healthyChildrenUrl, googleVertexCommerceVisitorId, disableGenerativeAIOverview, disableGenerativeAIOverviewAllAAPContext, disableGenerativeAIOverviewHealthyChildrenContext, generativeAIOverviewForceEnglishLanguage, recaptchaV3SiteKey } = (window as any).bootstrap;

    root.render(
        <VertexSearchPageApp
            epiProps={epiProps}
            showHealthyChildrenBranding={showHealthyChildrenBranding}
            healthyChildrenUrl={healthyChildrenUrl}
            googleVertexCommerceVisitorId={googleVertexCommerceVisitorId}
            disableGenerativeAIOverview={disableGenerativeAIOverview}
            disableGenerativeAIOverviewAllAAPContext={disableGenerativeAIOverviewAllAAPContext}
            disableGenerativeAIOverviewHealthyChildrenContext={disableGenerativeAIOverviewHealthyChildrenContext}
            generativeAIOverviewForceEnglishLanguage={generativeAIOverviewForceEnglishLanguage}
            recaptchaV3SiteKey={recaptchaV3SiteKey}
        />
    );
}